import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const UnivapayPaymentMob = () => {
  return <CommonProcess />;
};

export default UnivapayPaymentMob;
